import styled from 'styled-components/macro';
// import { motion } from 'framer-motion';
import px2vw from '../../utils/px2vw';
import { defaultStyle } from './/GlobalStyles';

// Default component Values
// Grid Default values
const padding = 0
const margin = 0

export const Grid = styled.div`
    padding: ${props => { 
        return props.p?px2vw(props.p):px2vw(padding)
    }};
    padding-left: ${props => { 
        return props.pl?px2vw(props.pl): px2vw(200);
    }};
    padding-right: ${props => { 
        return props.pr?px2vw(props.pr): px2vw(200);
    }};
    margin: ${props => { 
        return props.m?px2vw(props.m):px2vw(margin)
    }};
    margin-top: ${props => { 
        return props.mt?px2vw(props.mt):px2vw(0)
    }};
    margin-bottom: ${props => { 
        return props.mb?px2vw(props.mb):px2vw(0)
    }};
    background-color: ${props => props.bgColor};
    flex-wrap: wrap;

    p {
        color: ${props => props.fontColor}; 
    }

    @media screen and (max-width: 425px) {     
        padding-left: ${props => { 
        return props.pl?px2vw(props.pl): px2vw(35);
        }};
        padding-right: ${props => { 
            return props.pr?px2vw(props.pr): px2vw(35);
        }};
    }
`;

export const BorderBoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${props => { 
        return props.p?px2vw(props.p):px2vw(padding)
    }};
    padding-left: ${props => { 
        return props.pl?px2vw(props.pl):px2vw(0)
    }};
    padding-right: ${props => { 
        return props.pr?px2vw(props.pr):px2vw(0)
    }};
    margin: ${props => { 
        return props.m?px2vw(props.m):px2vw(margin)
    }};
    margin-top: ${props => { 
        return props.mt?px2vw(props.mt):px2vw(0)
    }};
    margin-bottom: ${props => { 
        return props.mb?px2vw(props.mb):px2vw(0)
    }};
    background-color: ${props => props.bgColor};
    position: relative;
    bottom: ${props => { 
        return props.bottom?px2vw(props.bottom):px2vw(0)
    }};
    width: ${props => { 
        return props.width?px2vw(props.width):px2vw(0)
    }};
    max-width: ${props => { 
        return props.width?px2vw(props.width):px2vw(0)
    }};
    z-index: 100;

    clip-path: polygon(${props => { 
        return props.clip?px2vw(props.clip):px2vw(0)
    }} 0, 
    100% 0, 
    100% 100%, 
    ${props => { 
        return props.clip?px2vw(props.clip):px2vw(0)
    }} 100%);
    
    /* @media screen and (max-width: 2560px) {     
        display: none;
    }
    @media only screen and (max-width: 1440px) {
        display: flex;
    }
    @media only screen and (max-width: 1024px) {
        display: none;
    }
    @media only screen and (max-width: 768px) {
        display: none;
    }
    @media screen and (max-width: 425px) {     
        display: none;
    }
    @media screen and (max-width: 320px) {     
        display: none;
    } */
`;

export const BorderBox = styled.div`
    position: relative;
    float: right;
    clip-path: polygon(48 0, 100% 0, 100% 100%, 48 100%);
    bottom: ${props => { 
        return props.bottom?px2vw(props.bottom):px2vw(0)
    }};
    left: ${props => { 
        return props.left?px2vw(props.left):px2vw(0)
    }};
    right: ${props => { 
        return props.right?px2vw(props.right):px2vw(0)
    }};
    height: ${props => { 
        return props.height?px2vw(props.height):px2vw(0)
    }};
    width: ${props => { 
        return props.width?px2vw(props.width):px2vw(0)
    }};
    background-color: ${props => { 
        return props.bgColor || 'red';
    }};
`;

export const StyledGrid = (props) => {
    return (
        <>
            <BorderBoxContainer pl="100" pr="100" bottom="-9" width="149.61" clip="99.61">
                <BorderBox width="122" height="18" bottom="-6" bgColor={props.color1} left="-48"></BorderBox>
                <BorderBox width="122" height="18" bgColor={props.color2} left="-20.39"></BorderBox>
            </BorderBoxContainer>
            <Grid m={props.m} p={props.p} bgColor={props.bgColor} fontColor={props.fontColor}></Grid>
        </>
    )
}

export const Box = styled.div`
    display: flex;
    /* width: 100%; */
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
`;

export const StyledGrid2 = (props) => {
    return (
        <>
            <Box>
                <BorderBoxContainer pl="100" pr="100" bottom="-9" width="149.61" clip="99.61">
                    <BorderBox width="122" height="18" bottom="-6" bgColor={props.color1} right="0"></BorderBox>
                    <BorderBox width="122" height="18" bgColor={props.color2} right="0"></BorderBox>
                </BorderBoxContainer>
                <Grid m={props.m} p={props.p} bgColor={props.bgColor} fontColor={props.fontColor}></Grid>
            </Box>
        </>
    )
}

export const Row = styled.div`
    display: flex;
    position: ${props => { 
        return props.position?props.position:'static'        
    }};
    color: ${props => props.textColor || 'none'};
    justify-content: ${props => props.justifyContent || 'flex-start'};
    padding: ${props => { 
        return props.p?px2vw(props.p):px2vw(0)
    }};
    padding-left: ${props => { 
        return props.pl?px2vw(props.pl):px2vw(0)        
    }};
    padding-right: ${props => { 
        return props.pr?px2vw(props.pr):px2vw(0)
    }};
    padding-top: ${props => { 
        return props.pt?px2vw(props.pt):px2vw(0)
    }};
    padding-bottom: ${props => { 
        return props.pb?px2vw(props.pb):px2vw(0)
    }};
    margin: ${props => { 
        return props.m?px2vw(props.m):px2vw(0)
    }};
    margin-top: ${props => { 
        return props.mt?px2vw(props.mt):px2vw(0)
    }};
    margin-bottom: ${props => { 
        return props.mb?px2vw(props.mb):px2vw(0)
    }};    
    background-color: ${props => props.backgroundColor || 'none'};
`;

const media = {
    xs: (styles) => `
        @media only screen and (max-width: 480px) {
            ${styles}
        }
    `
}

export const Col = styled.div`
    flex: ${(props) => props.size};
    background-color: ${props => props.backgroundColor || 'none'};
    color: ${props => props.textColor || 'none'};
    padding: ${props => { 
        return props.p?px2vw(props.p):px2vw(0)
    }};
    padding-left: ${props => { 
        return props.pl?px2vw(props.pl):px2vw(0)
    }};
    padding-right: ${props => { 
        return props.pr?px2vw(props.pr):px2vw(0)
    }};
    padding-top: ${props => { 
        return props.pt?px2vw(props.pt):px2vw(0)
    }};
    padding-bottom: ${props => { 
        return props.pb?px2vw(props.pb):px2vw(0)
    }};
    margin: ${props => { 
        return props.m?px2vw(props.m):px2vw(0)
    }};
    margin-top: ${props => { 
        return props.mt?px2vw(props.mt):px2vw(0)
    }};
    margin-bottom: ${props => { 
        return props.mb?px2vw(props.mb):px2vw(0)
    }};
    ${(props) => props.collapse && media[props.collapse](`
        display: none;
    `)}
`;

export const PageTitle = styled.h2`
    margin-top: ${props => { 
        return props.mt?px2vw(props.mt):px2vw(98)
    }};
    margin-bottom: ${props => { 
        return props.mb?px2vw(props.mb):px2vw(63)
    }};

    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: #000000;

    @media only screen and (max-width: 768px) {
        margin-top:40px;
    }

    @media only screen and (max-width: 1024px) {
        margin-top:80px;
    }
`;